import Vue from 'vue'
import { has, get, isObject } from 'lodash-es'
import { v1 as uuidv1 } from 'uuid'

import MUTATION_TYPES from './mutation-types'
import CONSTANTS from './constants'
import QUICKBUY_ITEM from '@/js/helper/quickbuy-item-constants.js'

export default {
  [MUTATION_TYPES.SET_AVAILABILITIES]: (
    state,
    { availabilities, type = CONSTANTS.AVAILABILITY_CONSTANTS.PAGE },
  ) => {
    if (!isObject(availabilities)) return

    const availability = get(state, CONSTANTS.AVAILABILITY_CONSTANTS.AVAILABILITY, {})

    const transformedAvailabilities = Object.values(availabilities).reduce(
      (availabilities, value) => ({ ...availabilities, ...value }),
      {},
    )

    Vue.set(availability, type, { ...availability[type], ...transformedAvailabilities })
  },
  [MUTATION_TYPES.CLEAR_AVAILABILITIES_BY_TYPE]: (state, type) => {
    state[CONSTANTS.AVAILABILITY_CONSTANTS.AVAILABILITY][type] = {}
  },
  [MUTATION_TYPES.SET_DETAILPAGE_URL]: (state, url) => {
    state[CONSTANTS.DETAILPAGE_URL] = url
  },
  [MUTATION_TYPES.ADD_DETAIL_DATASHEETS]: (state, datasheets) => {
    if (!datasheets) {
      return
    }
    const datasheetArray = Array.isArray(datasheets) ? datasheets : [datasheets]
    datasheetArray.forEach(({ url, name }) => {
      if (!has(state[CONSTANTS.DETAIL_DATASHEETS], url)) {
        Vue.set(state[CONSTANTS.DETAIL_DATASHEETS], url, {
          url,
          names: [],
        })
      }
      state[CONSTANTS.DETAIL_DATASHEETS][url].names.push(name)
    })
  },
  [MUTATION_TYPES.CLEAR_DETAIL_DATASHEETS]: state => {
    state[CONSTANTS.DETAIL_DATASHEETS] = {}
  },
  [MUTATION_TYPES.SET_PRODUCTS_REQUEST_PARAMS]: (state, data) => {
    state[CONSTANTS.PRODUCTS_REQUEST_PARAMS] = data
  },
  [MUTATION_TYPES.SET_PRODUCT_REQUEST_PARAMS]: (state, data) => {
    state[CONSTANTS.PRODUCT_REQUEST_PARAMS] = data
  },
  // ToDo: Remove mutation below
  [MUTATION_TYPES.SET_CATALOGTREE_PATH]: (state, { path, id }) => {
    Vue.set(state[CONSTANTS.CATALOGTREE_PATH], id, path)
  },
  [MUTATION_TYPES.SET_CATALOGTAB_ID]: (state, id) => {
    state[CONSTANTS.CATALOGTAB_ID] = id
  },
  [MUTATION_TYPES.ADD_SNSEARCH_RESULT]: (state, items = []) => {
    const maxItems = 5
    const currentItemCount = Object.keys(get(state, CONSTANTS.SNSEARCH_LIST, {})).length
    const newItemsCount = Object.keys([...items]).length
    const newItems = [...items]
    if (currentItemCount + newItemsCount > maxItems) {
      const itemsToDeleteCount = currentItemCount + newItemsCount - maxItems
      const itemsToDelete = Object.keys(state[CONSTANTS.SNSEARCH_LIST]).slice(0, itemsToDeleteCount)
      itemsToDelete.forEach(id => {
        Vue.delete(state[CONSTANTS.SNSEARCH_LIST], id)
      })
    }
    newItems.forEach(i => {
      const newId = get(i, 'id', uuidv1())
      const id = has(state[CONSTANTS.SNSEARCH_LIST], newId) ? newId : uuidv1()
      Vue.set(state[CONSTANTS.SNSEARCH_LIST], id, {
        ...i,
        id,
      })
    })
  },
  [MUTATION_TYPES.ADD_QUICKBUY_ITEMS]: (state, items = []) => {
    // const lastItem = last(Object.values(state[CONSTANTS.QUICKBUY_LIST]))
    // const deleteLast = lastItem && items.length > 0 && lastItem[QUICKBUY_ITEM.SKU] === ''

    ;[
      ...items,
      // ...(deleteLast ? [{ [QUICKBUY_ITEM.SKU]: '', [QUICKBUY_ITEM.AMOUNT]: 1 }] : []),
    ].forEach(i => {
      const newId = get(i, QUICKBUY_ITEM.ID, uuidv1())
      const id = has(state[CONSTANTS.QUICKBUY_LIST], newId) ? newId : uuidv1()
      Vue.set(state[CONSTANTS.QUICKBUY_LIST], id, {
        ...i,
        id,
      })
    })
    // if (deleteLast) {
    //   Vue.delete(state[CONSTANTS.QUICKBUY_LIST], lastItem[QUICKBUY_ITEM.ID])
    // }
  },
  [MUTATION_TYPES.MODIFY_QUICKBUY_ITEM]: (state, item) => {
    const id = get(item, QUICKBUY_ITEM.ID)
    if (!id || !has(state[CONSTANTS.QUICKBUY_LIST], id)) {
      return
    }
    Vue.set(state[CONSTANTS.QUICKBUY_LIST], id, { ...state[CONSTANTS.QUICKBUY_LIST][id], ...item })
  },
  [MUTATION_TYPES.REMOVE_QUICKBUY_ITEM]: (state, items = []) => {
    const ids = Array.isArray(items) ? items.map(item => get(item, 'id')) : [get(items, 'id')]
    ids.forEach(id => {
      if (!id || !has(state[CONSTANTS.QUICKBUY_LIST], id)) {
        return
      }
      Vue.delete(state[CONSTANTS.QUICKBUY_LIST], id)
    })
  },
  [MUTATION_TYPES.REMOVE_QUICKBUY_ALL_ITEMS]: state => {
    state[CONSTANTS.QUICKBUY_LIST] = {}
  },
}
